import { multipleSortComparison } from "./multipleSortComparison";

export default multipleSortComparison;
